<ng-container *ngIf="(authState$ | async)?.type !== PendingState">
  <div class="price-type-explanation" fxLayout="row" fxLayoutAlign="space-between start">
    <p class="price-type-explanation__message">
      {{ 'CORE.ALL_PAGES.PRICE_SWITCH.MOBILE.EXPLANATION_MESSAGE_1' | translate }}
      <a class="price-type-explanation__message__switch-link" (click)="switchPriceTypeToB2C()">
        {{ 'CORE.ALL_PAGES.PRICE_SWITCH.MOBILE.EXPLANATION_MESSAGE_2' | translate }}
      </a>
    </p>

    <button
      mm-button
      color="ghost-mute"
      class="price-type-explanation__close"
      (click)="closePriceTypeExplanation()">
      <mm-icon name="close-search" class="price-type-explanation__close-icon"></mm-icon>
    </button>
  </div>
</ng-container>
